(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-3d-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-3d-try')) {
    customElements.define(
      'jne-3d-try',
      class JneThreeDTry extends HTMLElement {
        connectedCallback() {
          const hidden = this.querySelector('[data-jne-3d-colors]');
          const name = this.querySelector('#sp3d-name');
          this.querySelectorAll('.jne-3d__swatch').forEach((swatch) => {
            swatch.addEventListener('click', () => {
              this.querySelectorAll('.jne-3d__swatch').forEach((s) => s.setAttribute('aria-checked', String(s === swatch)));
              hidden.value = swatch.dataset.colors;
              hidden.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
          // Letters, numbers, spaces and # only, in capitals like the real product
          name.addEventListener('input', () => {
            // Tags are printed without accents: É → E, Œ → OE
            const clean = name.value.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/œ/gi, 'OE').replace(/æ/gi, 'AE').toUpperCase().replace(/[^A-Z0-9 #-]/g, '');
            if (clean !== name.value) name.value = clean;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-carousel')) {
    customElements.define(
      'jne-carousel',
      class JneCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.jne-carousel__track');
          const root = this.closest('.jne-carousel');
          this.prev = root.querySelector('[data-jne-prev]');
          this.next = root.querySelector('[data-jne-next]');
          if (!this.track || !this.prev || !this.next) return;

          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        go(direction) {
          const item = this.track.querySelector('.jne-carousel__item');
          const step = item ? item.getBoundingClientRect().width : this.track.clientWidth;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const left = Math.abs(this.track.scrollLeft);
          this.prev.disabled = left <= 2;
          this.next.disabled = left >= max;
          this.closest('.jne-carousel').classList.toggle('jne-carousel--static', max <= 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-hero-3d"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-hero-3d')) {
    customElements.define(
      'jne-hero-3d',
      class JneHero3d extends HTMLElement {
        connectedCallback() {
          this.name = this.querySelector('#sp3d-name');
          this.number = this.querySelector('[data-jne-h3d-number]');
          this.sport = this.querySelector('[data-jne-h3d-sport]');
          this.colors = this.querySelector('[data-jne-h3d-colors]');
          this.cta = this.querySelector('[data-jne-h3d-cta]');
          this.ctaLabel = this.querySelector('[data-jne-h3d-cta-label]');
          this.template = this.cta.dataset.template || '';
          this.activeChip = this.querySelector('.jne-h3d__chip[aria-checked="true"]');

          this.querySelectorAll('.jne-h3d__chip').forEach((chip) => {
            chip.addEventListener('click', () => this.pick(chip, '.jne-h3d__chip', () => {
              this.activeChip = chip;
              const sport = chip.dataset.sport;
              this.sport.value = sport.charAt(0).toUpperCase() + sport.slice(1);
              this.sport.dispatchEvent(new Event('change', { bubbles: true }));
            }));
          });
          this.querySelectorAll('.jne-3d__swatch').forEach((swatch) => {
            swatch.addEventListener('click', () => this.pick(swatch, '.jne-3d__swatch', () => {
              this.colors.value = swatch.dataset.colors;
              this.colors.dispatchEvent(new Event('change', { bubbles: true }));
            }));
          });
          this.name.addEventListener('input', () => {
            // Tags are printed without accents: É → E, Œ → OE
            const clean = this.name.value.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/œ/gi, 'OE').replace(/æ/gi, 'AE').toUpperCase().replace(/[^A-Z0-9 #-]/g, '');
            if (clean !== this.name.value) this.name.value = clean;
            this.updateCta();
            this.tryOn();
          });

          if (this.number) {
            this.number.addEventListener('input', () => {
              const clean = this.number.value.toUpperCase().replace(/[^0-9A-Z#]/g, '');
              if (clean !== this.number.value) this.number.value = clean;
              this.updateCta();
              this.tryOn();
            });
          }

          // Let the page scroll vertically on touch; the model still rotates horizontally
          const viewer = document.getElementById('sp3d-viewer');
          if (viewer) viewer.setAttribute('touch-action', 'pan-y');
          this.updateCta();

          // Real photo first, then the 3D preview takes over automatically (once the model is ready)
          this.photos = this.querySelectorAll('.jne-h3d__photo');
          this.thumbs = this.querySelectorAll('.jne-h3d__thumb');
          this.modelReady = !viewer || viewer.loaded;
          if (viewer && !this.modelReady) {
            viewer.addEventListener('load', () => {
              this.modelReady = true;
              if (this.revealDue) this.show('3d');
            }, { once: true });
          }
          if (!this.photos.length) {
            this.show('3d');
            return;
          }
          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.autoOff = true;
              clearTimeout(this.autoTimer);
              this.show(thumb.dataset.show);
            });
          });
          this.autoTimer = setTimeout(() => {
            if (this.autoOff) return;
            this.revealDue = true;
            if (this.modelReady) this.show('3d');
          }, Number(this.dataset.revealDelay) || 3000);
        }

        show(target) {
          const is3d = target === '3d';
          this.revealDue = false;
          this.classList.toggle('is-3d', is3d);
          if (!is3d) this.photos.forEach((p) => p.classList.toggle('is-active', p.dataset.photo === String(target)));
          if (this.thumbs) this.thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.show === String(target))));
        }

        pick(button, selector, apply) {
          this.querySelectorAll(selector).forEach((b) => b.setAttribute('aria-checked', String(b === button)));
          apply();
          this.updateCta();
          this.tryOn();
        }

        // Any try-on action (sport, name, colors) shows the 3D preview right away
        tryOn() {
          this.autoOff = true;
          clearTimeout(this.autoTimer);
          if (!this.classList.contains('is-3d')) this.show('3d');
        }

        updateCta() {
          const chip = this.activeChip;
          if (!chip) return;
          const params = new URLSearchParams();
          const name = this.name.value.trim();
          if (name) params.set('jne_name', name);
          const number = this.number ? this.number.value.trim() : '';
          if (number) params.set('jne_number', number);
          params.set('jne_colors', this.colors.value);
          this.cta.href = chip.dataset.url + '?' + params.toString();
          const moreColors = this.querySelector('[data-jne-h3d-more-colors]');
          if (moreColors) {
            params.delete('jne_colors');
            moreColors.href = chip.dataset.url + '?' + params.toString();
          }
          if (this.template) this.ctaLabel.textContent = this.template.replace('[price]', chip.dataset.price);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-hero-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-hero-gallery')) {
    customElements.define(
      'jne-hero-gallery',
      class JneHeroGallery extends HTMLElement {
        connectedCallback() {
          this.photos = this.querySelectorAll('.jne-h3d__photo');
          this.thumbs = this.querySelectorAll('.jne-h3d__thumb');
          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.stop();
              this.show(thumb.dataset.show);
            });
          });
          // Gently rotate the photos until the visitor picks one
          if (this.photos.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.current = 1;
            this.timer = setInterval(() => {
              this.current = (this.current % this.photos.length) + 1;
              this.show(this.current);
            }, 4500);
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        stop() {
          clearInterval(this.timer);
        }

        show(target) {
          this.photos.forEach((p) => p.classList.toggle('is-active', p.dataset.photo === String(target)));
          this.thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.show === String(target))));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-how-3d"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-how-3d')) {
    customElements.define(
      'jne-how-3d',
      class JneHow3d extends HTMLElement {
        connectedCallback() {
          const sport = this.querySelector('[data-jne-how-sport]');
          const colors = this.querySelector('[data-jne-how-colors]');
          const name = this.querySelector('[data-jne-how-name]');
          const pick = (selector, button) =>
            this.querySelectorAll(selector).forEach((b) => b.setAttribute('aria-checked', String(b === button)));
          const model = this.querySelector('[data-jne-how-model]');
          const start = this.querySelector('[data-jne-how-start]');
          const moreSports = this.querySelector('[data-jne-how-more-sports]');
          const moreColors = this.querySelector('[data-jne-how-more-colors]');
          const chips = this.querySelectorAll('.jne-h3d__chip[data-sport]');
          const setSport = (chip) => {
            pick('.jne-h3d__chip[data-sport]', chip);
            const s = chip.dataset.sport;
            sport.value = s.charAt(0).toUpperCase() + s.slice(1);
            sport.dispatchEvent(new Event('change', { bubbles: true }));
          };
          const number = this.querySelector('[data-jne-how-number]');
          const cta = this.querySelector('[data-jne-how-cta]');
          const buy = this.querySelector('[data-jne-how-buy]');
          const buy2 = this.querySelector('[data-jne-how-buy2]');
          const buyLbl = this.querySelector('[data-jne-how-buylbl]');
          const stickyName = this.querySelector('[data-jne-how-stickyname]');
          const sticky = this.querySelector('[data-jne-how-sticky]');
          const T = {
            buy: this.dataset.tBuy || '{name}',
            buyDesign: this.dataset.tBuyDesign || '',
            buyMedal: this.dataset.tBuyMedal || '',
            stickyBtn: this.dataset.tSticky || '',
            stickyMedal: this.dataset.tStickyMedal || ''
          };
          const colorName = this.querySelector('[data-jne-how-colorname]');
          const currentModel = () => (model && model.value) || 'tag';
          const medalExtras = [];
          const applyModelFields = () => {
            const medal = currentModel() === 'medal';
            name.name = medal ? 'properties[text_02_1]' : 'properties[name_1]';
            if (number) number.name = medal ? 'properties[text_03_1]' : 'properties[text_02_1]';
            medalExtras.splice(0).forEach((el) => el.remove());
            if (medal) {
              [['name_1', (this.dataset.demoTeam || 'BRAVES')], ['text_04_1', String(new Date().getFullYear())]].forEach(([k, v]) => {
                const h = document.createElement('input');
                h.type = 'hidden';
                h.name = 'properties[' + k + ']';
                h.value = v;
                name.parentNode.appendChild(h);
                medalExtras.push(h);
              });
            }
            name.dispatchEvent(new Event('input', { bubbles: true }));
          };
          // Tags print the number as "#12"; nameplates and medals print it as typed
          const fmtNumber = (v) => {
            v = String(v || '').trim().toUpperCase();
            const digits = v.replace(/^#/, '');
            if (!digits) return '';
            return currentModel() === 'tag' && /^\d+$/.test(digits) ? '#' + digits : digits;
          };
          const links = () => {
            const design = this.querySelector('.jne-how__design[aria-checked="true"]');
            const chip = this.querySelector('.jne-h3d__chip[data-sport][aria-checked="true"]');
            const bySport = {};
            ((design && design.dataset.products) || '').split(',').filter(Boolean).forEach((pair) => {
              const i = pair.indexOf(':');
              bySport[pair.slice(0, i)] = pair.slice(i + 1);
            });
            const productUrl = (chip && bySport[chip.dataset.sport]) || (design ? design.dataset.product : (cta ? cta.getAttribute('href') : '/collections/all'));
            const listUrl = design ? design.dataset.link : productUrl;
            const params = new URLSearchParams();
            if (name.value.trim()) params.set('jne_name', name.value.trim());
            if (number && number.value.trim()) params.set('jne_number', number.value.trim());
            if (colors.value) params.set('jne_colors', colors.value);
            const q = params.toString() ? '?' + params.toString() : '';
            if (start) start.href = listUrl;
            if (moreSports) moreSports.href = listUrl;
            if (moreColors) moreColors.href = productUrl + q;
            if (cta) cta.href = productUrl + q;
            // Order: tags and nameplates go straight to the cart; medals open prefilled (team name + year to set)
            const medal = currentModel() === 'medal';
            const buyParams = new URLSearchParams(params);
            if (!medal && name.value.trim()) buyParams.set('jne_buy', '1');
            const buyUrl = productUrl + (buyParams.toString() ? '?' + buyParams.toString() : '');
            if (buy) buy.href = buyUrl;
            if (buy2) buy2.href = buyUrl;
            const who = [name.value.trim(), number ? fmtNumber(number.value) : ''].filter(Boolean).join(' ').slice(0, 20);
            if (buyLbl) buyLbl.textContent = medal ? T.buyMedal : (who ? T.buy.replace('{name}', who) : T.buyDesign);
            if (stickyName) stickyName.textContent = who || T.buyDesign;
            if (buy2) buy2.textContent = medal ? T.stickyMedal : T.stickyBtn;
          };
          // Product choice: switch the 3D shape and only offer the sports that exist for it
          this.querySelectorAll('.jne-how__design').forEach((design) => {
            design.addEventListener('click', () => {
              pick('.jne-how__design', design);
              const allowed = (design.dataset.sports || '').split(',').filter(Boolean);
              let current = this.querySelector('.jne-h3d__chip[data-sport][aria-checked="true"]');
              chips.forEach((chip) => { chip.hidden = allowed.length > 0 && !allowed.includes(chip.dataset.sport); });
              model.value = design.dataset.model;
              if (current && current.hidden) setSport([...chips].find((chip) => !chip.hidden));
              model.dispatchEvent(new Event('change', { bubbles: true }));
              if (number) { number.value = fmtNumber(number.value); number.dispatchEvent(new Event('input', { bubbles: true })); }
              applyModelFields();
              links();
            });
          });

          chips.forEach((chip) => chip.addEventListener('click', () => { setSport(chip); links(); }));
          // Apply the first product's sports on load
          const firstDesign = this.querySelector('.jne-how__design[aria-checked="true"]');
          if (firstDesign) {
            const allowed = (firstDesign.dataset.sports || '').split(',').filter(Boolean);
            chips.forEach((chip) => { chip.hidden = allowed.length > 0 && !allowed.includes(chip.dataset.sport); });
          }
          const showColorName = (b) => { if (colorName && b) colorName.textContent = b.dataset.label || ''; };
          this.querySelectorAll('.jne-how__combo[data-colors]').forEach((combo) => {
            combo.addEventListener('click', () => {
              pick('.jne-how__combo[data-colors]', combo);
              colors.value = combo.dataset.colors;
              colors.dispatchEvent(new Event('change', { bubbles: true }));
              showColorName(combo);
              links();
            });
          });
          const firstCombo = this.querySelector('.jne-how__combo[aria-checked="true"]');
          if (firstCombo) { colors.value = firstCombo.dataset.colors; showColorName(firstCombo); }
          if (number) {
            number.addEventListener('input', () => { links(); });
            number.addEventListener('blur', () => {
              const v = fmtNumber(number.value);
              if (v !== number.value) { number.value = v; number.dispatchEvent(new Event('input', { bubbles: true })); }
            });
          }
          // Tags are printed without accents: É → E, Œ → OE
          name.addEventListener('input', () => {
            const clean = name.value.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/œ/gi, 'OE').replace(/æ/gi, 'AE').toUpperCase().replace(/[^A-Z0-9 #-]/g, '');
            if (clean !== name.value) name.value = clean;
            links();
          });
          applyModelFields();
          links();
          // Mobile: an order bar while the demo is on screen and the main button is not
          if (sticky && buy && 'IntersectionObserver' in window) {
            let inSection = false;
            let buyVisible = false;
            const mq = window.matchMedia('(max-width: 749px)');
            const sync = () => {
              const show = mq.matches && inSection && !buyVisible;
              sticky.hidden = !show;
              sticky.classList.toggle('is-on', show);
              document.documentElement.classList.toggle('jne-how-sticky-on', show);
            };
            new IntersectionObserver((e) => { inSection = e[0].isIntersecting; sync(); }, { rootMargin: '-35% 0px -10% 0px' }).observe(this);
            new IntersectionObserver((e) => { buyVisible = e[0].isIntersecting; sync(); }).observe(buy);
            if (mq.addEventListener) mq.addEventListener('change', sync);
          }
          // Let the page scroll vertically on touch; the model still rotates horizontally
          const viewer = document.getElementById('sp3d-viewer');
          if (viewer) viewer.setAttribute('touch-action', 'pan-y');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jne-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jne-sticky-cta')) {
    customElements.define(
      'jne-sticky-cta',
      class JneStickyCta extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('.jne-sticky__button');
          const roster = document.getElementById('team-roster');
          const atc = document.querySelector('.product-form__submit');
          this.anchor = roster || atc;
          if (!this.anchor) return;
          if (!roster) button.setAttribute('href', '#');
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            (roster ? roster.nextElementSibling || roster : atc).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          });

          const title = document.querySelector('.product__title');
          const actions = [roster && roster.nextElementSibling, atc].filter(Boolean);
          const onScreen = (el) => {
            const r = el.getBoundingClientRect();
            return r.bottom > 0 && r.top < window.innerHeight;
          };
          this.update = () => {
            this.frame = null;
            const beforeTitle = title ? title.getBoundingClientRect().bottom > 0 : window.scrollY < 400;
            this.hidden = beforeTitle || actions.some(onScreen);
            document.body.classList.toggle('jne-sticky-on', !this.hidden);
          };
          this.onScroll = () => {
            if (!this.frame) this.frame = requestAnimationFrame(this.update);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          document.body.classList.remove('jne-sticky-on');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
